import React from 'react'
import { whatIdo as data} from '../data'
import PageTitle from '../components/PageTitle'
import { FaRegAddressCard } from 'react-icons/fa'

const Home = () => {
  return (
      <section className='home_page'>
      <PageTitle title='About me' icon={<FaRegAddressCard/>}/>
      <p className='objective'>
        Front-End Web Developer <strong>React JS</strong>, UI/UX Designer, Graphic designer and WordPress developer. Currently in Cairo, Egypt, looking for a new and challenging position as a Front-end developer or UI/UX designer where I can create digital magic and elevate user experience to the next level.
        </p>

        <h1 className='h1'>What I do!</h1>
        <div className='skills-container'>
        {
          data && data.map(({id, title,icon,desc, color})=>{
            return(
              <div className={`skill-card bg-soft-${color}`} key={id}>
                <div className={`icon text-center text-${color}`}>
                  {icon}
                </div>
                <div className="text">
                  <h4 className='text-secondary'>{title}</h4>
                  <p>{desc}</p>
                </div>
              </div>
            )
          })
        }
        </div>

        <div className="clients-slider">
          <h1 className='h1'>{' '}</h1>
        </div>

      </section>
  )
}

export default Home